/**
 * 进度跟踪器类
 */
class ProgressTracker {
    constructor(totalSize, progressCallback) {
        this.totalSize = totalSize;
        this.progressCallback = progressCallback;
        this.uploadedBytes = 0;
        this.completedParts = new Set();
        this.startTime = Date.now();
    }

    updateProgress(partNumber, partSize) {
        if (!this.completedParts.has(partNumber)) {
            this.completedParts.add(partNumber);
            this.uploadedBytes += partSize;
        }

        const percent = parseFloat((this.uploadedBytes / this.totalSize).toFixed(4));
        const elapsed = Date.now() - this.startTime;
        const speed = elapsed > 0 ? this.uploadedBytes / elapsed * 1000 : 0; // bytes per second
        const eta = speed > 0 ? (this.totalSize - this.uploadedBytes) / speed : 0; // seconds

        if (this.progressCallback) {
            this.progressCallback({
                loaded: this.uploadedBytes,
                total: this.totalSize,
                percent: percent,
                part: partNumber,
                speed: speed,
                eta: eta,
                type: 'progress',
            });
        }
    }

    reset() {
        this.uploadedBytes = 0;
        this.completedParts.clear();
        this.startTime = Date.now();
    }

    setCompletedParts(completedPartNumbers, partsInfo = []) {
        this.completedParts = new Set(completedPartNumbers);
        // 根据已完成的分片计算已上传的字节数
        this.uploadedBytes = partsInfo
            .filter(part => this.completedParts.has(part.PartNumber))
            .reduce((sum, part) => sum + (part.Size || 0), 0);
    }
}

module.exports = ProgressTracker;